import { render } from "./TripleDevice.vue?vue&type=template&id=6f479b3a&scoped=true"
import script from "./TripleDevice.vue?vue&type=script&lang=js"
export * from "./TripleDevice.vue?vue&type=script&lang=js"

import "./TripleDevice.vue?vue&type=style&index=0&id=6f479b3a&scoped=true&lang=scss"

import exportComponent from "/Users/pnz002/Project/dfy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f479b3a"]])

export default __exports__